/**
 * FAB Container Main
 * @class FABContainerMain
 * @static
 * @method isMainContainerHidden
 * @method getMainContainerClass
 * @method getMainContainerStyle
 */
export default class FABContainerMain {
  /**
   * Check if the main container should be hidden
   * - FAB Setting Page: Template -> Name -> Hidden
   * @returns {boolean}
   */
  static isMainContainerHidden = () => {
    let { fab_design } = window.FAB_PLUGIN.options;
    return fab_design.template && fab_design.template.name === 'hidden' ? true : false;
  };

  /**
   * Get the main container class
   * - FAB Setting Page: Template -> Name
   * - FAB Setting Page: Layout -> Position
   *
   * @param {string} position
   * @returns {string}
   */
  static getMainContainerClass = (position) => {
    let { template } = window.FAB_PLUGIN.options.fab_design;
    let classes = 'fab-floating-button px-4 fixed flex gap-3 ';

    // Add the position class
    classes += position.includes('center') ? 'flex-row' : 'flex-col';
    classes += ` fab-position-${position}`;

    // Set the template class: There're 3 types of templates: classic, shape, and hidden.
    classes += ` fab-template-${template.name}`;

    // Set the shape class.
    classes += template.shape ? ` fab-template-shape-container-${template.shape}` : '';

    return classes;
  };

  /**
   * Get the main container style
   * @returns {string}
   */
  static getMainContainerStyle = () => {
    let { layout, font } = window.FAB_PLUGIN.options.fab_design;
    let { margin } = layout;
    let style = ' z-index: 9999; ';

    // Set the margin style: top, right, bottom, and left.
    let marginStyle = [];
    marginStyle.push(margin.top ? `${margin.top}${margin.sizing}` : '0');
    marginStyle.push(margin.right ? `${margin.right}${margin.sizing}` : '0');
    marginStyle.push(margin.bottom ? `${margin.bottom}${margin.sizing}` : '0');
    marginStyle.push(margin.left ? `${margin.left}${margin.sizing}` : '0');
    style += `margin: ${marginStyle.join(' ')};`;

    // Set the font
    style += `font-size: ${font.size.value}${font.size.unit};`;
    style += `font-family: ${font.family};`;
    style += font.style === 'bold' ? `font-weight: bold;` : `font-style: ${font.style};`;

    return style;
  };
}
